import { Typography, useMediaQuery } from "@mui/material";
import BoldSpanText from "components/shared/BoldSpanText";
import PageSection from "components/shared/PageSection";
// assets
import NodesBackgroundVideo from "assets/videos/page-backgrounds/istockphoto-nodes-blue.mp4";

/**
 * * Groundbreaking Technology page of the Platform section
 * @returns {React.ReactElement} GroundbreakingTechnologyPage
 */
export default function GroundbreakingTechnologyPage() {
  return (
    <PageSection
      id="platform-section-GroundbreakingTechnology"
      backgroundVideoSrc={NodesBackgroundVideo}
      sx={{ backgroundColor: "#3332" }}
    >
      <SectionText />
    </PageSection>
  );
}

/**
 * * Text for the Groundbreaking Technology page
 * @param {Object} props
 * @returns {React.ReactElement} SectionText
 */
function SectionText(props) {
  return (
    <>
      <SectionHeaderText {...props} />
      <Typography variant="h6" color="common.black" my={2} {...props}>
        Our patented platform utilizes
        <BoldSpanText> Deep Learning </BoldSpanText>
        and
        <BoldSpanText> 3D Holographic Imaging </BoldSpanText>to analyze
        individual cells and, for the first time, has revealed accurate
        proteomic insights missed using current non-cell-based approaches.
      </Typography>
      <Typography variant="overline" color="common.black" mt={4} {...props}>
        <BoldSpanText>IP: </BoldSpanText>BROAD AND EXTENSIVE IP PORTFOLIO OF 30+
        PATENT FILINGS
      </Typography>
    </>
  );
}

/**
 * * Header text for the Groundbreaking Technology page
 * @param {Object} props
 * @returns {React.ReactElement} SectionHeaderText
 */
function SectionHeaderText(props) {
  const greaterThanSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <>
      {greaterThanSm ? (
        <Typography variant="h2" color="primary" fontWeight="bold" {...props}>
          Groundbreaking technology
        </Typography>
      ) : (
        <>
          <Typography variant="h2" color="primary" fontWeight="bold" {...props}>
            Ground-
          </Typography>
          <Typography variant="h2" color="primary" fontWeight="bold" {...props}>
            breaking
          </Typography>
          <Typography variant="h2" color="primary" fontWeight="bold" {...props}>
            technology
          </Typography>
        </>
      )}
    </>
  );
}
